import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const animation = () => {
    gsap.from(".audience__fans", {
        x: 200,
        opacity: 0,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
            trigger: ".audience",
            start: window.innerWidth > 557 ? "top 10%" : "top 50%",
            once: false,
        }
    });

    const counters = document.querySelectorAll(".number-section__block-stat span");

    counters.forEach((span) => {
        const endValue = Number(span.textContent.replace(/\s/g, "")); // убираем пробелы
        span.textContent = "0";

        gsap.to(span, {
            innerText: endValue,
            duration: 2,
            ease: "power1.out",
            snap: {innerText: 1},
            scrollTrigger: {
                trigger: ".number-section",
                start: "top 50%",
                once: false
            },
            onUpdate: function () {
                span.textContent = Math.floor(span.innerText).toLocaleString("ru-RU");
            }
        });
    });


    if (window.innerWidth > 557) {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".victories-section",
                start: "top 20%",
                once: false
            }
        });

        tl.from(".victories-section__block-cup", {
            opacity: 0,
            y: 30,
            scale: 0.9,
            duration: 0.8,
            ease: "power3.out",
            stagger: 0.15
        });

        tl.from(".victories-section__block-info", {
            opacity: 0,
            y: 20,
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.1
        }, "-=0.3");

        tl.from(".victories-section__block-year", {
            opacity: 0,
            y: 15,
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.1
        }, "-=0.4");
    }
};
